import store from '../store';
import { jwtDecode } from 'jwt-decode';
import {refreshAccessToken} from "./request"
export const setToken = (accessToken, refreshToken) =>{
   document.cookie = `accessToken=${accessToken}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
   document.cookie = `refreshToken=${refreshToken}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
   localStorage.setItem('vue_token', accessToken);
   localStorage.setItem('ref_token', refreshToken);
   setStore(accessToken, refreshToken, true)
}

export const setAccessToken = (accessToken) =>{
   document.cookie = `accessToken=${accessToken}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=simplifymycareer.com;`;
   localStorage.setItem('vue_token', accessToken);
   store.commit("userVUEX/setAccessToken", accessToken);
}


export const getUserID =()=>{
    let decodedToken = jwtDecode(getToken());
    return decodedToken.sub;
}

export const setStore=(accessToken, refreshToken,loginStatus)=>{
    store.commit("userVUEX/setAccessToken", accessToken);
    store.commit("userVUEX/setRefreshToken", refreshToken);
    store.commit("userVUEX/setLoginStatus", loginStatus);
}

export const clearCookies = () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
        name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=hire3x.com;";
    }
  };

  export const checkAccess = (project) => {
    if (document.cookie.length > 0) {
      let data = document.cookie.split(";");
      for (let i in data) {
        let cur = data[i].split("=");
        if (cur[0].trim() === project) {
          if (cur[1] === 'no-access') {
            return false;
          } else {
            return true;
          }
        }
      }
    }
    return false;
  }

  export const checkTokenExpiry = () => {
    let cookieToken=getToken();
    let decoded = jwtDecode(cookieToken);
    let time = null;
    let currentTime = Math.floor((new Date()).getTime())
    if (currentTime >= decoded.exp * 1000) {
      time = false;
    } else {
      time = true;
    }
    return time;
  };

  export const getToken = () => {
    if (document.cookie.length > 0) {
      let data = document.cookie.split(";");
      for (let i in data) {
        let cur = data[i].split("=");
        if (cur[0].trim() === "accessToken") {
          return cur[1];
        }
      }
    }
    return null;
  };
  
  export const getRefreshToken = () => {
    if (document.cookie.length > 0) {
      let data = document.cookie.split(";");
      for (let i in data) {
        let cur = data[i].split("=");
        if (cur[0].trim() === "refreshToken") {
          return cur[1];
        }
      }
    }
    return null;
  };

  export const startTokenExpiryWatcher = () => {
    setInterval(async () => {
      if (checkBeforeTokenExpiry()) {
        // Token is expiring within the next 1 minute
        // Refresh the token
        await refreshAccessToken();
      }
    }, 60000); // Check every 1 minute
  };
  
  export const checkBeforeTokenExpiry = () => {
    let cookieToken = getToken();
    let decoded = jwtDecode(cookieToken);
    let expirationTime = decoded.exp * 1000;
    let currentTime = Math.floor(new Date().getTime());
    let timeDifference = expirationTime - currentTime;
    console.log(timeDifference);
    //check if token expires within 5 minutes
    if (timeDifference <= 300000) {
      return true;
    } else {
      return false;
    }
  };

  export const getLoginType = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        console.log(cur[0])
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
}
  